import Component from 'gia/Component'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);



class Cover extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element
    this.el = $(element)


    this.ref = {
      tagline: "",
      img:"",
      landscape: [],
      video: null,
      mobile: null
    }
  }

  mount() {

    gsap.fromTo(
      this.ref.img, {
        ease: 'none',
        yPercent: 0
      }, {
        scrollTrigger: {
          trigger: this.element,
          start: 'top top',
          end: "bottom top",
          scrub: true
        },
        ease: 'none',
        yPercent: 20
      }
    )


    gsap.to(
      this.ref.tagline, {
        scrollTrigger: {
          trigger: this.element,
          start: 'top top',
          end: "bottom top",
          scrub: true
        },
        ease: 'none',
        yPercent: 30
      
      }
    )

    gsap.to(
      this.ref.landscape[2], {
        scrollTrigger: {
          trigger: this.element,
          start: 'top top',
          end: "bottom top",
          scrub: true
        },
        ease: 'none',
        yPercent: 25,
        opacity: -0.5
      }
    )

    gsap.to(
      this.ref.landscape[1], {
        scrollTrigger: {
          trigger: this.element,
          start: 'top top',
          end: "bottom top",
          scrub: true
        },
        ease: 'none',
        yPercent: 15,
        opacity: -0.25
      }
    )


    gsap.to(
      this.ref.landscape[3], {
        scrollTrigger: {
          trigger: this.element,
          start: 'top top',
          end: "bottom top",
          scrub: true
        },
        ease: 'none',
        yPercent: 35,
        opacity: -0.5
      }
    )

    gsap.to(
      this.ref.landscape[4], {
        scrollTrigger: {
          trigger: this.element,
          start: 'top top',
          end: "bottom top",
          scrub: true
        },
        ease: 'none',
        yPercent: 20,
        opacity: -0.25
      }
    )

    gsap.to(
      this.ref.landscape[6], {
        scrollTrigger: {
          trigger: this.element,
          start: 'top top',
          end: "bottom top",
          scrub: true
        },
        ease: 'none',
        yPercent: 35,
        opacity: -0.5
      }
    )

    gsap.to(
      this.ref.landscape[7], {
        scrollTrigger: {
          trigger: this.element,
          start: 'top top',
          end: "bottom top",
          scrub: true
        },
        ease: 'none',
        yPercent: 20,
        opacity: -0.25
      }
    )


     gsap.to(
       this.ref.landscape[0], {
         scrollTrigger: {
           trigger: this.element,
           start: 'top top',
           end: "bottom top",
           scrub: true
         },
         ease: 'none',
         yPercent: 5,
         opacity: 1
       }
     )

     gsap.to(
       this.ref.landscape[5], {
         scrollTrigger: {
           trigger: this.element,
           start: 'top top',
           end: "bottom top",
           scrub: true
         },
         ease: 'none',
         yPercent: 20,
         opacity: 1
       }
     )

     gsap.to(
       this.ref.landscape[8], {
         scrollTrigger: {
           trigger: this.element,
           start: 'top top',
           end: "bottom top",
           scrub: true
         },
         ease: 'none',
         yPercent: 20,
         opacity: 1
       }
     )

     gsap.to(
       this.ref.landscape[9], {
         scrollTrigger: {
           trigger: this.element,
           start: 'top top',
           end: "bottom top",
           scrub: true
         },
         ease: 'none',
         yPercent: 50,
         opacity: 0
       }
     )

     gsap.to(
       this.ref.landscape[10], {
         scrollTrigger: {
           trigger: this.element,
           start: 'top top',
           end: "bottom top",
           scrub: true
         },
         ease: 'none',
         yPercent: 50,
         opacity: 0
       }
     )

    var x = window.matchMedia("(max-width: 680px)")
    this.matcher(x.matches)
    x.addEventListener('change', (e) => {
      this.matcher(e.matches)
    }) // Attach listener function on state changes
  
  }

  matcher(mobile) {

    if (this.ref.video) {
      if (mobile) {
        if (this.ref.mobile) {
          this.ref.mobile = false
          //console.log('nothing')
        } else {
          $(this.ref.video).html('');
          $(this.ref.video).html('<video src="/images/vertical.mp4" autoplay playsinline loop muted></video>')
        }
      } else {
        $(this.ref.video).html('');
        $(this.ref.video).html('<video src="/images/landscape.mp4" autoplay playsinline loop muted></video>')
      }

      $(this.ref.video).addClass('loaded')
    }
  }

  changeImg() {

  
  }


  unmount() {

  }


}

module.exports = Cover
